import { useState } from 'react'
import { useAdministrativeContext } from '../../../../../../../pages/administrativePanel/administrativePanelContext'
import { api } from '../../../../../../../services/api'
import { useDispatch } from 'react-redux'
import { Button } from '../../../../../../Button'
import { Franchise } from '../Franchise'

import { Container, ContainerFranchise, ContainerButton } from './style'
import { toast } from 'react-toastify'

export function FranchiseList() {
    const { 
        franchiseList, 
        franchiseListCodesSelected, 
        setFranchiseListCodesSelected,
        setListBusinessToFilter 
    } = useAdministrativeContext()
    const [franchiseListChecked, setFranchiseListChecked] = useState(franchiseListCodesSelected)
    const [loading, setLoading] = useState(false)

    const dispatch = useDispatch()
    const token = localStorage.getItem('@Inoveclube:token')

    async function handleClickToApply() {
        setLoading(true)

        await api.get(`/getBusinessByFranchises/${franchiseListChecked}/${token}`)
            .then(response => {
                setListBusinessToFilter(response.data)
                setFranchiseListCodesSelected(franchiseListChecked)
                dispatch({type: '', title: 'Filtrar empresas'})
            })
            .catch(() => toast.error('Algo deu errado, tente novamente'))
            .finally(() => setLoading(false))
    }


    return (
        <Container>
            <h2>Franquias</h2>

            <ContainerFranchise>
                {
                    franchiseList.map(franchise => (
                        <Franchise 
                            key={franchise.id}
                            franchise={franchise}
                            franchiseListChecked={franchiseListChecked}
                            setFranchiseListChecked={setFranchiseListChecked}
                        />
                    ))
                }
            </ContainerFranchise>

            <ContainerButton isDisabled={!franchiseListChecked.length}>
                <Button
                    onClick={handleClickToApply}
                    background="#7A05A7"
                    isLoading={loading}
                    color="#FFF"
                >
                    Aplicar
                </Button>
            </ContainerButton>
        </Container>
    )
}